import React, { useState, useEffect, Fragment } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { ReferenciaCabecera } from "../../../interfaces/ReferenciaCabecera";
import Breadcrumb from "../../atoms/breadcrumb/breadcrumb";
import CardPodcast from "../../atoms/card-podcast/cardPodcast";

import "./headboardPodcast.scss";

const HeadboardPodcast = (props: ReferenciaCabecera) => {
  const [sliderIndex, setSliderIndex] = useState(0);
  const [slider, setSlider] = useState<any>();
  const [infoArray, setInfoArray] = useState<any>([]);

  useEffect(() => {
    if (props[0]) {
      const auxArr: Array<any> = [];
      for (const key in props) {
        auxArr.push(props[key]);
      }
      setInfoArray(auxArr);
    }
  }, [props]);

  const goToNext = () => {
    slider.slickGoTo(sliderIndex + 1);
  };

  const goToBack = () => {
    slider.slickGoTo(sliderIndex - 1);
  };

  const isActiveBack = (_true: any, _false: any) =>
    sliderIndex > 0 ? _true : _false;

  const isActiveNext = (_true: any, _false: any) =>
    sliderIndex < infoArray.length - 1 ? _true : _false;

  const settings = {
    arrows: false,
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    beforeChange: (_: number, next: number) => setSliderIndex(next),
  };

  return (
    <section className="o-headboard-podcast">
      <div className="hide-on-mobile">
        <Breadcrumb content={`${props[0].migaDePan}`} />
      </div>
      <Slider
        ref={(_slider) => setSlider(_slider)}
        {...settings}
        className="o-headboard-podcast__carousel"
      >
        {infoArray.map((value, index) => (
          <Fragment key={index}>
            <CardPodcast podcast={value} breadCrumbs={props[0].migaDePan} />
          </Fragment>
        ))}
      </Slider>

      <div
        className="arrow-content arrow-content__left hide-on-mobile"
        onClick={isActiveBack(goToBack, undefined)}
      >
        <div className="arrows">
          <div className="arrows-contain">
            <div
              className={isActiveBack(
                "arrow icon-chevron-left active",
                "arrow icon-chevron-left"
              )}
            />
          </div>
        </div>
      </div>

      <div
        className="arrow-content arrow-content__right hide-on-mobile"
        onClick={isActiveNext(goToNext, undefined)}
      >
        <div className="arrows">
          <div className="arrows-contain">
            <div
              className={isActiveNext(
                "arrow icon-chevron-right active",
                "arrow icon-chevron-right"
              )}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeadboardPodcast;
